<template>
	<div style="">
		<div class="container-fluid">
			<loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
			<div class="row" v-if="!active">
				<div class="col-lg-4 col-12" style="background: #FEF6E3;">
				</div>
				<div class="col-lg-4 col-12" style="background: white; height: 100vh">
					<div class="login--wrap">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="login--logo">
										<Logo />
									</div>
									<span class="head login--title">Get Started</span>
									<br />
									<span class="head--sub">Create a ContestCrate Account.</span>
									<form class="login--form" method="post">
										<input class="input--text email login--input-bottom" type="email" v-model="email" placeholder="Email adres" name="email" />
										<input class="input--text password login--input-bottom" type="text" v-model="name" placeholder="Name" name="name" />
										<input class="input--text password login--input-bottom" type="password" v-model="password" placeholder="Password" name="password" />
									</form>
								</div>
								<div class="col-lg-12 col-12">
									<span class="form--error" v-for="error in errors" :key="error">
										{{ error }}
										<br />
									</span>
									<button class="btn btn-primary login--button-main" @click="signUp">
										Sign Up
									</button>
									<router-link class-active="" class="" :to="{ name: 'login', params: { param: null } }">
										<div class="login--forgot">I already have an account.</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-12" style="background: #FEF6E3;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import Logo from "../components/Logo";
	import Loading from "vue-loading-overlay";
	import "vue-loading-overlay/dist/vue-loading.css";
	export default {
		name: "Register",
		components: {
			Loading,
			Logo,
		},
		data() {
			return {
				isLoading: false,
				fullPage: true,
				errors: null,

				email: null,
				password: null,
				name: null,

				active: false,
			};
		},
		mounted() {
			if (this.$route.query.email) {
				this.email = this.$route.query.email;
			}
		},
		methods: {
			signUp() {
				var self = this;
				this.isLoading = true;
				axios({
						method: "POST",
						crossdomain: true,
						headers: {
							"Content-Type": "Content-Type:application/json"
						},
						url: "/user/register",
						data: {
							email: self.email,
							password: self.password,
							name: self.name,
						},
						body: {
							email: self.email,
							password: self.password,
							name: self.name,
						},
					})
					.then(function(response) {
						self.isLoading = false;
						localStorage.token = response.data.token;
						localStorage.newAccount = false;
						self.$globals.getContests();
						self.$router.push("/");
					})
					.catch(function(error) {
						self.errors = error.data;
						self.isLoading = false;
					});
			},

			register() {
				this.active = true;
			},
		},
	};
</script>